import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import { Button, Icon } from 'semantic-ui-react';
import AgGridTable from '../common/agGridTable'
function HeaderCTAPlanning() {
    let columnDefs = []
    return (
        <>
            <div className="display-flex-center-justify-spacebtwn">
                <div>
                    <Button basic className="font-weight-500">
                        <Icon name='file pdf' /> PDF
                    </Button>
                </div>
                <div>
                    <Button basic className="font-weight-500">
                        <Icon name='file excel' /> Excel
                    </Button>
                </div>
                <div>
                    <Button basic className="font-weight-500">
                        <Icon name='print' /> Print
                    </Button>
                </div>
            </div>
        </>
    )
}

export default HeaderCTAPlanning
